export const STATUTS_OFFRE = {
  EN_PREPARATION: 'En préparation',
  REMISE: 'Remise',
  GAGNE: 'Gagnée',
  PERDU: 'Perdue',
  ABANDONNE: 'Abandonnée'
};
export const OFFRE_DEFAULTS = {
  heureRemise: '',
  echeanceConfirmee: false,
  sourceEcheance: '',
  responsableUid: '',
  responsableNom: '',
  statutOffre: 'EN_PREPARATION',
  dateDepot: '',
  preuveDepot: '',
  delaiRappelJours: 14,
  memoirePret: false,
  administratifPret: false,
  restitutionVerifiee: false
};
export function dateValide(s) {
  if (typeof s !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(s)) return false;
  const [y, m, d] = s.split('-').map(Number),
    v = new Date(Date.UTC(y, m - 1, d));
  return v.getUTCFullYear() === y && v.getUTCMonth() === m - 1 && v.getUTCDate() === d;
}
export function heureValide(s) {
  return typeof s === 'string' && /^([01]\d|2[0-3]):[0-5]\d$/.test(s);
}
export function horlogeParis(now) {
  const p = Object.fromEntries(new Intl.DateTimeFormat('fr-FR', {
    timeZone: 'Europe/Paris',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23'
  }).formatToParts(now).map(x => [x.type, x.value]));
  return {
    date: `${p.year}-${p.month}-${p.day}`,
    heure: `${p.hour}:${p.minute}`
  };
}
export function etatEcheance(d, now = new Date()) {
  if (d.type === 'TMA' && ['ACCEPTE','EXECUTE','FACTURE','CLOS','REFUSE','ABANDONNE','ANNULE'].includes(d.tmaStatut || d.suiviTma?.statut)) return { niveau: 'CLOSE', label: 'TMA accepté ou clos', jours: null, ton: 'neutral' };
  const statut = d.statutOffre || 'EN_PREPARATION';
  if (statut !== 'EN_PREPARATION') return {
    niveau: 'CLOSE',
    label: STATUTS_OFFRE[statut] || 'Statut à vérifier',
    jours: null,
    ton: 'neutral'
  };
  if (!dateValide(d.echeance) || !d.echeanceConfirmee || !d.sourceEcheance?.trim()) return {
    niveau: 'A_CONFIRMER',
    label: 'Date à confirmer',
    jours: null,
    ton: 'warning'
  };
  const p = horlogeParis(now),
    jours = Math.round((Date.parse(d.echeance + 'T00:00:00Z') - Date.parse(p.date + 'T00:00:00Z')) / 86400000);
  if (jours < 0 || jours === 0 && heureValide(d.heureRemise) && p.heure > d.heureRemise) return {
    niveau: 'DEPASSEE',
    label: 'Échéance dépassée',
    jours,
    ton: 'danger'
  };
  if (jours === 0) return {
    niveau: 'AUJOURDHUI',
    label: heureValide(d.heureRemise) ? `Aujourd’hui à ${d.heureRemise}` : 'Aujourd’hui · heure à confirmer',
    jours,
    ton: 'warning'
  };
  return {
    niveau: jours <= 3 ? 'URGENTE' : jours <= 7 ? 'PROCHE' : 'NORMALE',
    label: `J-${jours}${heureValide(d.heureRemise) ? '' : ' · heure à confirmer'}`,
    jours,
    ton: jours <= 7 ? 'warning' : 'info'
  };
}
export function trierOffres(ds, now = new Date()) {
  const rang = {
    DEPASSEE: 0,
    AUJOURDHUI: 1,
    URGENTE: 2,
    A_CONFIRMER: 3,
    PROCHE: 4,
    NORMALE: 5,
    CLOSE: 6
  };
  return [...ds].sort((a, b) => {
    const x = etatEcheance(a, now),
      y = etatEcheance(b, now);
    return rang[x.niveau] - rang[y.niveau] || (a.echeance || '9999').localeCompare(b.echeance || '9999') || (a.heureRemise || '99').localeCompare(b.heureRemise || '99') || (a.nom || '').localeCompare(b.nom || '');
  });
}
export function rappelsUtilisateur(ds, uid, now = new Date()) {
  if (!uid) return [];
  return trierOffres(ds.filter(d => {
    if (d.responsableUid !== uid) return false;
    const e = etatEcheance(d, now),
      seuil = Number(d.delaiRappelJours ?? 14);
    return e.niveau !== 'CLOSE' && (e.jours === null || e.jours <= seuil);
  }), now);
}
export function depotArchiveValide(d) {
  return (d.depotsMarche || []).some(x => dateValide(x.date) && heureValide(x.heure) && x.reference?.trim() && x.preuve?.chemin?.startsWith(`chiffragePieces/${d.id}/`) && /^[a-f0-9]{64}$/.test(x.preuve.sha256 || '') && x.pieces?.length > 0);
}
export function validerSuiviOffre(d) {
  if (!Object.hasOwn(STATUTS_OFFRE, d.statutOffre || 'EN_PREPARATION')) throw new Error('Statut d’offre inconnu.');
  if (d.echeance && !dateValide(d.echeance)) throw new Error('Date de remise invalide.');
  if (d.heureRemise && !heureValide(d.heureRemise)) throw new Error('Heure de remise invalide.');
  if (d.echeanceConfirmee && (!dateValide(d.echeance) || !d.sourceEcheance?.trim())) throw new Error('Pour confirmer la date, renseignez sa source dans le RC ou la demande.');
  if (!Number.isInteger(Number(d.delaiRappelJours)) || Number(d.delaiRappelJours) < 1 || Number(d.delaiRappelJours) > 60) throw new Error('Le délai de rappel doit être compris entre 1 et 60 jours.');
  if (['REMISE', 'GAGNE', 'PERDU'].includes(d.statutOffre) && (!dateValide(d.dateDepot) || !d.preuveDepot?.trim())) throw new Error('Indiquer la date et la preuve de dépôt pour une offre remise.');
}


// Les anciens dépôts saisis en texte restent modifiables sans fabriquer de preuve.
// Toute nouvelle transition vers une remise exige désormais son récépissé archivé.
export function validerTransitionOffre(d, precedent) {
  if (d.type === 'MARCHE' && ['REMISE', 'GAGNE', 'PERDU'].includes(d.statutOffre)
      && !['REMISE', 'GAGNE', 'PERDU'].includes(precedent?.statutOffre) && !depotArchiveValide(d)) {
    throw new Error('Consigner le récépissé et les fichiers déposés dans Remise avant de changer ce statut.');
  }
}
